export const environment = {
  production: true,
  APIURL : 'https://digilocally.deloitte.co.il/webapi/api/',
  ImageURL :'https://digilocally.deloitte.co.il/assets/images/',
  Mobile:'https://m.digilocally.deloitte.co.il'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts